/**
 * Replace values with keys
 * @param str String from which text to be replaced.
 * @param values Matchiong keys with values.
 * @return {string} Replaced String
 */
export default function replaceText(str, values = {}) {
  for (let key in values) {
    let regex = new RegExp(`{{${key}}}`, "g");
    str = str.replace(regex, values[key]);
  }

  return str;
}
